export default "__VITE_ASSET__CRt1QR7I__"